import React from "react";
import { Check, ChevronDown } from "lucide-react";

/**
 * Custom dropdown button: "{label} **{value}**". `options` = [{ value, label, color }];
 * the first row clears the filter ("Any …"). Outside click closes the menu.
 */
const FilterDropdown = ({ label, anyLabel, options, value, open, onToggle, onClose, onChange }) => {
  const current = options.find((o) => o.value === value);
  return (
    <div className="er-dd">
      {open && <div className="er-ddshield" onClick={onClose} />}
      <button
        type="button"
        className={`er-btn er-ddbtn${value || open ? " on" : ""}`}
        onClick={onToggle}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {label} <b>{current ? current.label : "All"}</b>
        <ChevronDown size={13} strokeWidth={2} />
      </button>
      {open && (
        <div className="er-ddmenu" role="listbox" aria-label={label}>
          {[{ value: "", label: anyLabel, color: "var(--line2)" }, ...options].map((o) => {
            const on = (o.value || "") === (value || "");
            return (
              <button
                key={o.value || "any"}
                type="button"
                role="option"
                aria-selected={on}
                className={`er-btn er-ddopt${on ? " on" : ""}`}
                onClick={() => {
                  onChange(o.value);
                  onClose();
                }}
              >
                <i style={{ background: o.color }} />
                <span>{o.label}</span>
                {on && <Check size={14} strokeWidth={2.4} color="var(--accent)" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
